/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonChangeOfobject,
    JsonChangeOfobjectFromJSON,
    JsonChangeOfobjectFromJSONTyped,
    JsonChangeOfobjectToJSON,
} from './JsonChangeOfobject';

/**
 * 
 * @export
 * @interface JsonStrategy
 */
export interface JsonStrategy {
    /**
     * 
     * @type {Array<string>}
     * @memberof JsonStrategy
     */
    allowedActions?: Array<JsonStrategyAllowedActionsEnum>;
    /**
     * 
     * @type {Array<JsonChangeOfobject>}
     * @memberof JsonStrategy
     */
    changes?: Array<JsonChangeOfobject>;
    /**
     * 
     * @type {number}
     * @memberof JsonStrategy
     */
    companyId?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonStrategy
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonStrategy
     */
    createdBy?: number;
    /**
     * 
     * @type {number}
     * @memberof JsonStrategy
     */
    serieId?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonStrategy
     */
    status?: JsonStrategyStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof JsonStrategy
     */
    strategyId?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonStrategy
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof JsonStrategy
     */
    updatedAt?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonStrategy
     */
    updatedBy?: number;
}

/**
* @export
* @enum {string}
*/
export enum JsonStrategyAllowedActionsEnum {
    View = 'VIEW',
    Edit = 'EDIT'
}/**
* @export
* @enum {string}
*/
export enum JsonStrategyStatusEnum {
    Deleted = 'DELETED',
    Active = 'ACTIVE'
}

export function JsonStrategyFromJSON(json: any): JsonStrategy {
    return JsonStrategyFromJSONTyped(json, false);
}

export function JsonStrategyFromJSONTyped(json: any, ignoreDiscriminator: boolean): JsonStrategy {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'allowedActions': !exists(json, 'allowedActions') ? undefined : json['allowedActions'],
        'changes': !exists(json, 'changes') ? undefined : ((json['changes'] as Array<any>).map(JsonChangeOfobjectFromJSON)),
        'companyId': !exists(json, 'companyId') ? undefined : json['companyId'],
        'createdAt': !exists(json, 'createdAt') ? undefined : json['createdAt'],
        'createdBy': !exists(json, 'createdBy') ? undefined : json['createdBy'],
        'serieId': !exists(json, 'serieId') ? undefined : json['serieId'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'strategyId': !exists(json, 'strategyId') ? undefined : json['strategyId'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'updatedAt': !exists(json, 'updatedAt') ? undefined : json['updatedAt'],
        'updatedBy': !exists(json, 'updatedBy') ? undefined : json['updatedBy'],
    };
}

export function JsonStrategyToJSON(value?: JsonStrategy | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'allowedActions': value.allowedActions,
        'changes': value.changes === undefined ? undefined : ((value.changes as Array<any>).map(JsonChangeOfobjectToJSON)),
        'companyId': value.companyId,
        'createdAt': value.createdAt,
        'createdBy': value.createdBy,
        'serieId': value.serieId,
        'status': value.status,
        'strategyId': value.strategyId,
        'title': value.title,
        'updatedAt': value.updatedAt,
        'updatedBy': value.updatedBy,
    };
}

